
import { loadInformationPage, informationPageHead } from "~/utils/information-page";

export default {
    spacingDebug: false,
    components: {
        Breadcrumbs: () => import("~/components/global/Breadcrumbs"),
        InformationPanel: () => import("~/components/global/InformationPanel"),
    },
    async asyncData(context) {
        return loadInformationPage(context, {
            endpoint: "web/page/privacy-policy",
            title: "Privacy Policy",
            validate: (content) => typeof content.description === "string" && Boolean(content.description.trim()),
        });
    },
    computed: {
        jumbotronContent() {
            return {
                heading: { textContent: this.pageContentPayload.title || "Privacy Policy", level: "h1", alignment: "center" },
                body: { htmlContent: this.pageContentPayload.description, alignment: "left" },
                thumbnail: {
                    image: {
                        src:
                            typeof this.pageContentPayload.image === "string" && this.pageContentPayload.image.trim()
                                ? this.pageContentPayload.image.trim()
                                : "/assets/privacy-policy/dpo-[light].webp",
                        alt: "Data Protection Officer registration",
                    },
                },
            };
        },
    },
    mounted() {
        this.scrollToTop();
        if (this.pageContentPayload.ads?.length) {
            this.$store.commit("global/dialog/populateContents", { items: this.pageContentPayload.ads });
        }
    },
    head() {
        return informationPageHead(this.$route, "Privacy Policy", "Learn how Malayan Insurance handles personal information and protects your privacy.");
    },
};
